import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { offeringsDraftRoute } from '..';

export const offeringsDraftUpdatedCostRoute = createRoute({
  getParentRoute: () => offeringsDraftRoute,
  path: 'updated-cost',
  component: lazyRouteComponent(() => import('./OfferingsDraftUpdatedCostView')),
});
